import stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { FC } from 'react';

export const Chip: FC<{ text?: string | number }> = ({ text }) => {
  return <span {...stylex.props(styles.base)}>{text}</span>;
};
